module.exports = __webpack_public_path__ + "static/media/twitter-x.824b61df.svg";